import React, { useState, useEffect } from "react";
import { getSalaryRegister } from "../../api/salaryApi";
import { getAllAllowance } from "../../api/allowanceApi";
import { getAllDeduction } from "../../api/deductionApi";

export default function PaymentSlipReport({ reportName, month: parentMonth, year: parentYear }) {
  const [salaryData, setSalaryData] = useState([]);
  const [allowancesMaster, setAllowancesMaster] = useState([]);
  const [deductionsMaster, setDeductionsMaster] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const [company, setCompany] = useState(sessionStorage.getItem("companyName"));
  const [email, setEmail] = useState(sessionStorage.getItem("email"));
  const [address, setAddress] = useState(sessionStorage.getItem("address"));


  // Fetch master data
  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const allowance = await getAllAllowance();
        const deduction = await getAllDeduction();
        setAllowancesMaster(allowance);
        setDeductionsMaster(deduction);
      } catch (error) {
        console.error("Error fetching master data:", error);
      }
    };
    fetchMasterData();
  }, []);

  const handleShowReport = async () => {
    setErrorMessage("");
    if (!reportName || !parentMonth || !parentYear) {
      setErrorMessage("Please select Report Name and enter Month/Year");
      return;
    }

    const filters = {
      month: parseInt(parentMonth),
      year: parseInt(parentYear),
      departmentId: null,
      sectionId: null,
    };

    try {
      const data = await getSalaryRegister(filters);
      setSalaryData(data);
    } catch (error) {
      setSalaryData([]);
      setErrorMessage(error.message);
    }
  };

  const convertNumberToWords = (amount) => {
  const words = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];
  const scales = ["", "Thousand", "Lakh", "Crore"];

  if (amount === 0) return "Zero";

  let num = Math.floor(amount);
  let paise = Math.round((amount - num) * 100);

  const getWords = (n) => {
    let str = "";
    if (n > 19) {
      str += tens[Math.floor(n / 10)] + (n % 10 ? " " + words[n % 10] : "");
    } else {
      str += words[n];
    }
    return str;
  };

  let strWords = "";
  let scaleIndex = 0;

  while (num > 0) {
    let chunk;
    if (scaleIndex === 0) {
      chunk = num % 1000;
      num = Math.floor(num / 1000);
    } else {
      chunk = num % 100;
      num = Math.floor(num / 100);
    }

    if (chunk) {
      let chunkWords = "";
      if (chunk > 99) {
        chunkWords += words[Math.floor(chunk / 100)] + " Hundred ";
        chunk %= 100;
      }
      if (chunk) {
        chunkWords += getWords(chunk);
      }
      strWords = chunkWords + " " + scales[scaleIndex] + " " + strWords;
    }

    scaleIndex++;
  }

  strWords = strWords.trim() + " Rupees";
  if (paise > 0) {
    strWords += " and " + getWords(paise) + " Paise";
  }
  strWords += " Only";
  return strWords;
};

  const handleClear = () => {
    setSalaryData([]);
    setErrorMessage("");
  };


const handlePrintSingle = (employee) => {
  let printHTML = `
    <html>
      <head>
        <title>Salary Slip</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
          .page { padding: 15mm; border: 1px solid #000; }
          .header { text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 5px; }
          .company-info { text-align: center; font-size: 10px; margin: 2px 0 8px 0; }
          .emp-details {
            display: flex;
            flex-wrap: wrap;
            font-size: 10px;
            margin-bottom: 2px;
          }
          .emp-details div {
            width: 50%;
          }
          table { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
          th, td { border: 1px solid #000; padding: 4px; font-size: 12px; }
          .totals { font-weight: bold; display: flex; justify-content: space-between; margin: 8px 0; }
          .net-salary { font-size: 14px; font-weight: bold; text-align: right; }
        </style>
      </head>
      <body>
  `;

  const earnings = allowancesMaster.map((a, idx) => ({
    name: a.allowanceName,
    amount: employee[`allowance${idx + 1}`] || 0
  }));
  const deductions = deductionsMaster.map((d, idx) => ({
    name: d.deductionName,
    amount: employee[`deduction${idx + 1}`] || 0
  }));

  const totalEarnings = earnings.reduce((sum, e) => sum + (e.amount || 0), 0);
  const totalDeductions = deductions.reduce((sum, d) => sum + (d.amount || 0), 0);
  const netSalary = Math.round(totalEarnings - totalDeductions);
  const netSalaryWords = convertNumberToWords(netSalary);

  printHTML += `
    <div class="page">
      <div class="header"><strong>${company}</strong></div>
        <div class="company-info">
          <span>Email: ${email} | </span>
          <span>Address: ${address}</span>
          </div>
      <div class="emp-details">
          <div><strong>Name:</strong> ${employee.employeeName} (${employee.employeeCode})</div>
          <div><strong>PF UAN:</strong> ${employee.uanNo || "-"}</div>
          <div><strong>Section Code:</strong> ${employee.sectionName || "-"}</div>
          <div><strong>Department:</strong> ${employee.departmentName || "-"}</div>
          <div><strong>Total Days:</strong> ${employee.totalWorkingDays || "-"}</div>
          <div><strong>Present:</strong> ${employee.noOfPresentDays || "-"}</div>
          <div><strong>Pay Mode:</strong> ${employee.payMode || "-"}</div>
          <div><strong>Bank A/c:</strong> ${employee.bankAccountNo || "-"}</div>
        </div>
      <table>
        <thead>
          <tr>
            <th>EARNINGS</th>
            <th>Amount</th>
            <th>DEDUCTIONS</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          ${earnings.map((e, i) => `
            <tr>
              <td>${e.name}</td>
              <td style="text-align:right;">${e.amount.toFixed(2)}</td>
              <td>${deductions[i] ? deductions[i].name : ""}</td>
              <td style="text-align:right;">${deductions[i] ? deductions[i].amount.toFixed(2) : ""}</td>
            </tr>
          `).join("")}
        </tbody>
      </table>
      <p class="totals">
        <span>Earnings: ${totalEarnings.toFixed(2)}</span>
        <span>Deductions: ${totalDeductions.toFixed(2)}</span>
      </p>
      <p class="net-salary">
        Net Payable: ₹${netSalary} <br/>
        <small>(${netSalaryWords})</small>
      </p>
    </div>
  `;

  printHTML += `
      </body>
    </html>
  `;

  const printWindow = window.open("", "_blank");
  printWindow.document.write(printHTML);
  printWindow.document.close();
  printWindow.print();
};


const handlePrint = () => {
  if (!salaryData || salaryData.length === 0) {
    alert("No salary data to print");
    return;
  }

  // Convert numeric month (1-12) to full name
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const monthText = monthNames[parseInt(parentMonth, 10) - 1] || parentMonth;
  const monthYear = `${monthText} ${parentYear}`;

  let printHTML = `
    <html>
      <head>
        <title>Payment Slip Report</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            font-size: 10px;
          }
          h3 {
            text-align: center;
            margin: 6px 0;
            font-size: 13px;
            text-transform: uppercase;
          }

          .page {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            height: 275mm; /* A4 height */
            box-sizing: border-box;
            page-break-after: always;
            padding: 0;
          }

          .slip-container {
            flex: none; /* No flex growth */
            border: 1px solid #000;
            padding: 4px;
            margin-bottom: 50px;  /* margin-bottom: 4px; */
            box-sizing: border-box;
            height: calc((100% - 3px) / 3 - 6mm); /* Reduced fixed height  height: calc((100% - 8px) / 3 - 10mm) */
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: flex-start; /* Align content to top */
          }

          .slip-container:last-child {
            margin-bottom: 0;
          }

          .header {
            display: flex;
            justify-content: space-between;
            font-size: 9px;
            margin-bottom: 3px;
          }
          .header strong {
            font-size: 10px;
          }

          .emp-details {
            display: flex;
            flex-wrap: wrap;
            font-size: 10px; /* font-size: 8px; */
            margin-bottom: 2px;
          }
          .emp-details div {
            width: 50%;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 1px;
            table-layout: fixed;
          }
          th, td {
            border: 1px solid #000;
            padding: 0 2px;
            font-size: 10px;
            word-wrap: break-word;
          }
          th {
            background: #f1f1f1;
          }

          th:nth-child(3),
          td:nth-child(3) {
              width: 4px;  /* control the gap */
          }

          .totals {
            font-weight: bold;
            margin-top: auto; /* Push totals toward bottom if needed */
            display: flex;
            justify-content: space-between;
            font-size: 10px; /* font-size: 8px; */
          }
          .net-salary {
            text-align: right;
            font-weight: bold;
            margin: 2px 0;                    /* margin: 1px 0 0 0;*/
            font-size: 13px;
            padding: 0;
            line-height: 8px;  /* line-height: 10px; */
            word-wrap: break-word; /* in case the words are too long */
            white-space: normal;   /* ensures wrapping */
          }

          @page {
            size: A4 portrait;
            margin: 8mm;
          }

          @media print {
            body {
              zoom: 95%; /* Adjust for better A4 fit */
            }
          }
        </style>
      </head>
      <body>
        
        
  `;

  salaryData.forEach((employee, index) => {
    const earnings = allowancesMaster.map((a, idx) => ({
      name: a.allowanceName,
      amount: employee[`allowance${idx + 1}`] || 0
    }));
    const deductions = deductionsMaster.map((d, idx) => ({
      name: d.deductionName,
      amount: employee[`deduction${idx + 1}`] || 0
    }));

    const totalEarnings = earnings.reduce((sum, e) => sum + (e.amount || 0), 0);
    const totalDeductions = deductions.reduce((sum, d) => sum + (d.amount || 0), 0);
    const netSalary =  Math.round(totalEarnings - totalDeductions); //totalEarnings - totalDeductions;
    const netSalaryInWords = convertNumberToWords(netSalary);

    if (index % 3 === 0) {
      printHTML += `<div class="page">`;
    }

    printHTML += `
      <div class="slip-container">
        <div class="header">

          <strong>${company}</strong>
          <strong>Email: ${email}</strong>
          <strong>Address: ${address}</strong>
          <span>${monthText} ${parentYear}</span>
        </div>
        <div class="emp-details">
          <div><strong>Name:</strong> ${employee.employeeName} (${employee.employeeCode})</div>
          <div><strong>PF UAN:</strong> ${employee.uanNo || "-"}</div>
          <div><strong>Section Code:</strong> ${employee.sectionName || "-"}</div>
          <div><strong>Department:</strong> ${employee.departmentName || "-"}</div>
          <div><strong>Total Days:</strong> ${employee.totalWorkingDays || "-"}</div>
          <div><strong>Present:</strong> ${employee.noOfPresentDays || "-"}</div>
          <div><strong>Bank A/c:</strong> ${employee.bankAccountNo || "-"}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th>EARNINGS</th>
              <th>Amount</th>
              <th style="border: none; background: none;"></th> <!-- spacer -->
              <th>DEDUCTIONS</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            ${earnings.map((e, i) => `
              <tr>
                <td>${e.name}</td>
                <td style="text-align:right;">${e.amount.toFixed(2)}</td>
                <td style="border: none;"></td>
                <td>${deductions[i] ? deductions[i].name : ""}</td>
                <td style="text-align:right;">${deductions[i] ? deductions[i].amount.toFixed(2) : ""}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>
        <p class="totals">
          <span>Earnings: ${totalEarnings.toFixed(2)}</span>
          <span>Deductions: ${totalDeductions.toFixed(2)}</span>
        </p>
        
        <p class="net-salary">
          Net Payable: ₹${netSalary} <br/><br/>
          <small>(${convertNumberToWords(netSalary)})</small>
        </p>

      </div>
    `;

    if ((index + 1) % 3 === 0 || index === salaryData.length - 1) {
      printHTML += `</div>`;
    }
  });

  printHTML += `</body></html>`;

  const printWindow = window.open("", "", "height=900,width=1200");
  printWindow.document.write(printHTML);
  printWindow.document.close();
  printWindow.print();
};

  const mapAllowances = (row) =>
    allowancesMaster.map((a, index) => ({
      name: a.allowanceName,
      value: row[`allowance${index + 1}`] || 0,
    }));

  const mapDeductions = (row) =>
    deductionsMaster.map((d, index) => ({
      name: d.deductionName,
      value: row[`deduction${index + 1}`] || 0,
    }));

  return (
    <div className="container mt-4">
      <h3>Salary Slip</h3>

      <div className="row mb-3">
        <div className="col-6 d-flex align-items-end">
          <button onClick={handleShowReport} className="btn btn-primary btn-sm me-2">Show</button>
          
          <button onClick={handleClear} className="btn btn-secondary btn-sm">Clear</button>
          {/* <button onClick={handlePrint} className="btn btn-success btn-sm ms-2">Print</button> */}
          {salaryData.length > 0 && (
            <button onClick={handlePrint} className="btn btn-success btn-sm ms-2">Print All</button>
          )}
        </div>
      </div>

      {errorMessage && <p className="text-danger">{errorMessage}</p>}

      {salaryData.length > 0 && (
        <div id="paymentSlipContent">
          {salaryData.map((row, idx) => {
            const mappedAllowances = mapAllowances(row);
            const mappedDeductions = mapDeductions(row);

            return (
              <div key={idx} className="card mb-3 p-2">
                <h5 className="fw-bold">
                  Employee: {row.employeeName} ({row.employeeCode})
                </h5>
                {/* <p>Account: {row.bankAccountNo || "-"} | PF/UAN: {row.uanNo || "-"}</p> */}
                {/* <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>Account: {row.bankAccountNo || "-"}</span>
                  <span>PF/UAN: {row.uanNo || "-"}</span>
                </p> */}

                {/* <p>Total Days: {row.totalWorkingDays} | Present: {row.noOfPresentDays}</p> */}
                {/* <p className="fw-bold">Gross Salary: ₹{row.grossSalary}</p> */}

                <div className="row">
                  <div className="col-md-6">
                     <p style={{ marginBottom: '4px' }}><strong>Bank Account No.:</strong> {row.bankAccountNo || "-"}</p>
                     <p style={{ marginBottom: '4px' }}><strong>Total Days:</strong> {row.totalWorkingDays}</p>
                     <p style={{ marginBottom: '4px' }}><strong>Gross Salary:</strong> ₹{row.grossSalary}</p>
                     
                    <h6 className="fw-bold">EARNINGS</h6>
                    <table className="table table-sm table-bordered">
                      <tbody>
                        {mappedAllowances.map((a, i) => (
                          <tr key={i}>
                            <td>{a.name}</td>
                            <td className="text-end">{a.value}</td>
                          </tr>
                        ))}
                        <tr className="fw-bold table-light">
                          <td>Total Earnings</td>
                          <td className="text-end">{row.totalAllowance}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-6" >
                    {/* <p><strong>PF/UAN:</strong> {row.uanNo || "-"}</p> */}
                    <p style={{ marginBottom: '4px'}}><strong>PF/UAN No.:</strong> {row.uanNo || "-"}</p>
                    <p style={{ marginBottom: '4px' }}><strong>Present Days:</strong> {row.noOfPresentDays}</p>
                    {/* <p style={{ marginBottom: '4px' }}><strong>Gross Salary:</strong></p> */}
                    <h6 className="fw-bold">DEDUCTIONS</h6>
                    <table className="table table-sm table-bordered">
                      <tbody>
                        {mappedDeductions.map((d, i) => (
                          <tr key={i}>
                            <td>{d.name}</td>
                            <td className="text-end">{d.value}</td>
                          </tr>
                        ))}
                        <tr className="fw-bold table-light">
                          <td>Total Deductions</td>
                          <td className="text-end">{row.totalDeduction}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* <div className="text-end fw-bold">
                  Net Salary: ₹{row.netSalary}
                </div> */}

                <div className="text-end fw-bold">
                  Net Salary: ₹{Math.round(row.netSalary)}
                  <br />
                  <small>({convertNumberToWords(row.netSalary)})</small>
                </div>

                <div className="text-end mt-2">
                <button
                  onClick={() => handlePrintSingle(row)}
                  className="btn btn-outline-primary btn-sm"
                >
                  Print Slip
                </button>
              </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}






// const handlePrint = () => {
//   if (!salaryData || salaryData.length === 0) {
//     alert("No salary data to print");
//     return;
//   }

//   let printHTML = `
//     <html>
//       <head>
//         <title>Payment Slip Report</title>
//         <style>
//           body {
//             font-family: Arial, sans-serif;
//             margin: 0;
//             font-size: 10px;
//           }
//           h3 {
//             text-align: center;
//             margin: 6px 0;
//             font-size: 13px;
//             text-transform: uppercase;
//           }

//           .page {
//             display: flex;
//             flex-direction: column;
//             justify-content: flex-start;
//             height: 275mm; /* A4 height */
//             box-sizing: border-box;
//             page-break-after: always;
//             padding: 0;
//           }

//           .slip-container {
//             flex: 1 1 auto;
//             border: 1px solid #000;
//             padding: 4px;
//             margin-bottom: 3px;
//             box-sizing: border-box;
//             height: calc((100% - 8px) / 3); /* 3 slips equally divided */
//             overflow: hidden;
//           }

//           .slip-container:last-child {
//             margin-bottom: 0;
//             padding-bottom: 0;
//           }

//           .header {
//             display: flex;
//             justify-content: space-between;
//             font-size: 9px;
//             margin-bottom: 3px;
//           }
//           .header strong {
//             font-size: 10px;
//           }

//           .emp-details {
//             display: flex;
//             flex-wrap: wrap;
//             font-size: 8px;
//             margin-bottom: 2px;
//           }
//           .emp-details div {
//             width: 50%;
//           }

//           table {
//             width: 100%;
//             border-collapse: collapse;
//             margin-top: 1px;
//             table-layout: fixed;
//           }
//           th, td {
//             border: 1px solid #000;
//             padding: 0 2px;
//             font-size: 8px;
//             word-wrap: break-word;
//           }
//           th {
//             background: #f1f1f1;
//           }

//           .totals {
//             font-weight: bold;
//             margin-top: 1px;
//             display: flex;
//             justify-content: space-between;
//             font-size: 8px;
//           }
//           .net-salary {
//             text-align: right;
//             font-weight: bold;
//             margin: 1px 0 0 0;
//             font-size: 9px;
//             padding: 0;
//             line-height: 10px;
//           }

//           @page {
//             size: A4 portrait;
//             margin: 8mm;
//           }

//           @media print {
//             body {
//               zoom: 95%; /* Adjust for better A4 fit */
//             }
//           }
//         </style>
//       </head>
//       <body>
//         <h3>Salary Slips - ${parentMonth}/${parentYear}</h3>
//   `;

//   salaryData.forEach((employee, index) => {
//     const earnings = allowancesMaster.map((a, idx) => ({
//       name: a.allowanceName,
//       amount: employee[`allowance${idx + 1}`] || 0
//     }));
//     const deductions = deductionsMaster.map((d, idx) => ({
//       name: d.deductionName,
//       amount: employee[`deduction${idx + 1}`] || 0
//     }));

//     const totalEarnings = earnings.reduce((sum, e) => sum + (e.amount || 0), 0);
//     const totalDeductions = deductions.reduce((sum, d) => sum + (d.amount || 0), 0);
//     const netSalary = totalEarnings - totalDeductions;

//     // New page after every 3 slips
//     if (index % 3 === 0) {
//       printHTML += `<div class="page">`;
//     }

//     printHTML += `
//       <div class="slip-container">
//         <div class="header">
//           <strong>AIM ENTERPRISES</strong>
//           <span>${parentMonth.toUpperCase()} ${parentYear}</span>
//         </div>
//         <div class="emp-details">
//           <div><strong>Name:</strong> ${employee.employeeName} (${employee.employeeCode})</div>
//           <div><strong>PF UAN:</strong> ${employee.uanNo || "-"}</div>
//           <div><strong>Site Code:</strong> ${employee.siteCode || "-"}</div>
//           <div><strong>Region:</strong> ${employee.region || "-"}</div>
//           <div><strong>Total Days:</strong> ${employee.totalWorkingDays || "-"}</div>
//           <div><strong>Present:</strong> ${employee.noOfPresentDays || "-"}</div>
//           <div><strong>Pay Mode:</strong> ${employee.payMode || "-"}</div>
//           <div><strong>Bank A/c:</strong> ${employee.bankAccountNo || "-"}</div>
//         </div>
//         <table>
//           <thead>
//             <tr>
//               <th>EARNINGS</th>
//               <th>Amount</th>
//               <th>DEDUCTIONS</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${earnings.map((e, i) => `
//               <tr>
//                 <td>${e.name}</td>
//                 <td style="text-align:right;">${e.amount.toFixed(2)}</td>
//                 <td>${deductions[i] ? deductions[i].name : ""}</td>
//                 <td style="text-align:right;">${deductions[i] ? deductions[i].amount.toFixed(2) : ""}</td>
//               </tr>
//             `).join("")}
//           </tbody>
//         </table>
//         <p class="totals">
//           <span>Earnings: ${totalEarnings.toFixed(2)}</span>
//           <span>Deductions: ${totalDeductions.toFixed(2)}</span>
//         </p>
//         <p class="net-salary">Net Payable: ${netSalary.toFixed(2)}</p>
//       </div>
//     `;

//     if ((index + 1) % 3 === 0 || index === salaryData.length - 1) {
//       printHTML += `</div>`; // Close page
//     }
//   });

//   printHTML += `</body></html>`;

//   const printWindow = window.open("", "", "height=900,width=1200");
//   printWindow.document.write(printHTML);
//   printWindow.document.close();
//   printWindow.print();
// };

